import { apiCall, apiFile, filterParams } from '../helpers/axios';

class AuctionService {

	static get() {
		return apiCall().get('/auctions?total=1000&sort=id')
			.then(response => response.data.data);
	}

	static getAll(params) {
		params = Object.assign({ sort: 'id', order: 'desc' }, params);

		return apiCall().get('/auctions', { params: params })
			.then(response => response.data);
	}

	static getOne(auctionId) {
		return apiCall().get(`/auctions/${auctionId}`)
			.then(response => response.data);
	}

	static create(auction) {
		return apiCall().post(`/auctions`, auction)
			.then(response => response.data);
	}

	static update(auctionId, data) {
		return apiCall().put(`/auctions/${auctionId}`, data)
			.then(response => response.data);
	}

	static delete(auctionId) {
		return apiCall().delete(`/auctions/${auctionId}`)
			.then(response => response.data);
	}

	static getAuctionItems(auctionId, params, cancelToken) {
		return apiCall().get(`/auctions/${auctionId}/items`, { params: filterParams(params), cancelToken: cancelToken })
			.then(response => response.data);
	}

	static getAuctionItemsExport(auctionId) {
		return apiCall().get(`auctions/${auctionId}/items/export`, {
            responseType: 'blob',
		}).then(response => response.data);
	}

	static getAuctionPersonItems(auctionId, personId, params, cancelToken) {
		return apiCall().get(`/auctions/${auctionId}/person/${personId}/items`, { params: filterParams(params), cancelToken: cancelToken })
			.then(response => response.data);
	}

	static getAuctionSellers(auctionId, params, cancelToken) {
		return apiCall().get(`/auctions/${auctionId}/sellers`, { params: filterParams(params), cancelToken: cancelToken })
			.then(response => response.data);
	}

	static getAuctionBuyers(auctionId, params, cancelToken) {
		return apiCall().get(`/auctions/${auctionId}/buyers`, { params: filterParams(params), cancelToken: cancelToken })
			.then(response => response.data);
	}

	static setAuctionOrderNumber(auctionId, data) {
		return apiCall().put(`/auctions/${auctionId}/item_orders`, data)
			.then(response => response.data);
	}

	static uploadMedia(auctionId, data) {
		return apiCall().post(`/auctions/${auctionId}/media`, data)
			.then(response => response.data)
	}

	static getAuctionOverview(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/financial`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}

	static getSellerListUrl(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/sellers_list`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}

	static getBuyerListUrl(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/buyers_list`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}

	static getBuyersSinceExport(auctionId, params) {
		return apiCall().post(`/auctions/${auctionId}/buyers_since`, params, {
            responseType: 'blob',
		}).then(response => response.data);
	}
}

export default AuctionService


// WEBPACK FOOTER //
// ./src/services/auction-service.js